import React  from 'react'
import { Link } from 'react-router-dom';
import Currencies from '../../../lib/Currencies';
 

const Card = ({brand , handleAddToCart}) => {

    const price = () => {
        const product = brand.products[0];
        return product.isVariablePrice ? 'Starting at ' + product.minVariablePrice : product.fixedPrice;
    }

    return (
        <div className="feature-item mb-5">
            <div className="card-img">
                <img src={brand.brandImageURL} alt={brand.brandName} />
            </div>
            <h6>{brand.brandName}</h6> 
            {brand.products.length && (<p>{price()} {Currencies.GetSymbol(brand.products[0].currency)}</p>)}
            <Link to={"/products/" + brand.variantID}><button className="btn-white">Buy Card</button></Link>
        </div>
    )
}

export default Card
